<template>
  <div class="search-inner">
      <div class="input-outer">
        <i class="iconfont iconsousuo to-search"></i>
        <input
          :value="keyVal"
          type="text"
          ref="search-input"
          :placeholder="placeholderText"
          @input.stop="toSearch"
          @keyup.stop
          @keydown.stop
          @click.stop="onFocus"
          @paste.stop
        />
        <i
          v-if="isFocused"
          class="iconfont iconguanbianniu2 clear"
          @click="toClear"
        ></i>
      </div>
    </div>
</template>

<script>


export default {
  name: 'Search',
  model: {
    prop: 'keyVal',
    event: 'inputAction',
  },
  props: {
    isFocused: {
      type: Boolean,
      default: false
    },
    keyVal: {
      type: String,
      default: '',
    },
    placeholderText: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  watch: {
  },
  mounted () {
    document.body.addEventListener('click', () => {
      if (this.keyVal === '') {
        if(this.isFocused) {
          this.$emit('onFocus', false);
        }
      }
    }, false);
  },
  methods: {
    toClear() {
      this.$emit('inputAction', '');
      this.$emit('searchAction', '');
      this.$emit('onFocus', false);
    },
    toSearch(e) {
      this.$emit('inputAction', e.target.value);
      this.$emit('searchAction', e.target.value);
    },
    onFocus () {
      this.$emit('onFocus', true);
    }
  }
};
</script>
<style lang="scss" scoped>
.search-inner {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  .input-outer {
    position: relative;
    flex-grow: 1;
    display: flex;
    align-items: center;
    height: 34px;
    border-bottom: 1px solid #D4D4E7;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 30px 0 30px;
    border-radius: 0 4px 4px 0;
    input {
      display: block;
      width: 100%;
      height: 100%;
      color: #474261;
      font-size: 12px;
      border: 0;
      outline: none;
      &::input-placeholder {
        color: #474261;
        opacity: 0.4;
      }
    }
    .clear {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #737596;
      cursor: pointer;
      font-size: 10px;
      transform: scale(0.8);
    }
    .to-search {
      position: absolute;
      top: 10px;
      left: 8px;
      z-index: 5;
      color: #737596;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/search.vue